import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import useAxiosProtect from '../../../../../../hooks/useAxiosProtect';

const HubModal = props => {
    const axiosProtect = useAxiosProtect();
    const siteId = Number(window.location.href.split('/').slice(-1));

    const [supplier, setSupplier] = useState('Milesight');
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');
    const [deveui, setDeveui] = useState('');
    const [edgecomLocationName, setEdgecomLocationName] = useState('');
    const [identifierError, setIdentifierError] = useState('');
    const [serverError, setServerError] = useState('');

    useEffect(() => {
        if(props.modalState !== 'edit' || !props.hubToEdit) return;

        setSupplier(props.hubToEdit.supplier_name);
        setName(props.hubToEdit.name || '');
        setDeveui(props.hubToEdit.deveui || '');
        setEdgecomLocationName(props.hubToEdit.edgecom_location_name || '');
    }, [props.modalState, props.hubToEdit]);

    const closeModal = () => {
        setSupplier('Milesight');
        setName('');
        setNameError('');
        setDeveui('');
        setEdgecomLocationName('');
        setIdentifierError('');
        setServerError('');
        props.closeModal();
    };

    const payload = () => ({
        site_id: siteId,
        name: name.trim(),
        supplier,
        edgecom_location_name: supplier === 'Edgecom' ? edgecomLocationName.trim() : '',
        deveui: supplier === 'Milesight' ? deveui.trim() : ''
    });

    const validate = () => {
        let isValid = true;
        const identifier = supplier === 'Edgecom' ? edgecomLocationName : deveui;
        if(name.trim() === ''){
            setNameError('Required');
            isValid = false;
        }else{
            setNameError('');
        }
        if(identifier.trim() === ''){
            setIdentifierError('Required');
            isValid = false;
        }else{
            setIdentifierError('');
        }

        return isValid;
    };

    const saveHub = async () => {
        if(!validate()) return;

        try{
            const body = payload();
            const response = props.modalState === 'add'
                ? await axiosProtect.post('/v2s/v2-sensors/hubs', body)
                : await axiosProtect.put('/v2s/v2-sensors/hubs', {
                    ...body,
                    hub_id: props.hubToEdit.id
                });

            props.saveHub(response.data.hub);
            closeModal();
        }catch(error){
            setServerError(error.response?.data?.error || 'Unable to save hub');
        }
    };

    const deleteHub = async () => {
        try{
            await axiosProtect.delete('/v2s/v2-sensors/hubs', {
                params: {
                    hub_id: props.hubToDelete.id,
                    site_id: siteId
                }
            });

            props.deleteHub(props.hubToDelete.id);
            closeModal();
        }catch(error){
            setServerError(error.response?.data?.error || 'Unable to delete hub');
        }
    };

    const selectedHub = props.hubToDelete || props.hubToEdit;

    return (
        <Modal
            show={props.modalState !== undefined}
            onHide={closeModal}
            backdrop="static"
            centered
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
        >
            <Modal.Header closeButton>
                <h4>{props.modalState === 'add' ? 'Add hub' : props.modalState === 'edit' ? 'Edit hub' : 'Delete hub'}</h4>
            </Modal.Header>

            <Modal.Body>
                {serverError !== '' && <p style={{color: 'red', textAlign: 'center'}}>{serverError}</p>}

                {['add', 'edit'].includes(props.modalState) && <>
                    <TextField
                        label="Name"
                        value={name}
                        onChange={event => setName(event.target.value)}
                        error={nameError !== ''}
                        helperText={nameError}
                        fullWidth
                        autoComplete="off"
                        style={{marginBottom: '1.5vh'}}
                    />

                    <FormControl fullWidth error={false}>
                        <InputLabel id="hub-supplier-label">Supplier</InputLabel>
                        <Select
                            labelId="hub-supplier-label"
                            value={supplier}
                            label="Supplier"
                            onChange={event => {
                                setSupplier(event.target.value);
                                setIdentifierError('');
                            }}
                            MenuProps={{disablePortal: true}}
                        >
                            <MenuItem value="Edgecom">Edgecom</MenuItem>
                            <MenuItem value="Milesight">Milesight</MenuItem>
                        </Select>
                    </FormControl>

                    {supplier === 'Edgecom' ? (
                        <TextField
                            label="Edgecom location name"
                            value={edgecomLocationName}
                            onChange={event => setEdgecomLocationName(event.target.value)}
                            error={identifierError !== ''}
                            helperText={identifierError}
                            fullWidth
                            autoComplete="off"
                            style={{marginTop: '1.5vh'}}
                        />
                    ) : (
                        <TextField
                            label="DevEUI"
                            value={deveui}
                            onChange={event => setDeveui(event.target.value)}
                            error={identifierError !== ''}
                            helperText={identifierError}
                            fullWidth
                            autoComplete="off"
                            style={{marginTop: '1.5vh'}}
                        />
                    )}
                    <FormHelperText>Only the supplier-specific hub identifier is stored.</FormHelperText>
                </>}

                {props.modalState === 'delete' && (
                    <p className="m-0">
                        Are you sure you want to delete <strong>{selectedHub?.name}</strong>?
                    </p>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    style={{backgroundColor: 'rgb(8,114,182)'}}
                    onClick={props.modalState === 'delete' ? deleteHub : saveHub}
                >
                    {props.modalState === 'add' ? 'Create' : props.modalState === 'edit' ? 'Save' : 'Delete'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default HubModal;
